import Vue from "vue";
import VueRouter from "vue-router";
import {dataLoggerRoutes} from "@/context/data_logger/router/DataLoggerRoutes";
import MeterRoutes from "@/context/meter/router/MeterRoutes";
import SensorRoutes from "@/context/sensor/router/SensorRoutes";
import AuthRoutes from "@/context/security/router/AuthRoutes";
import AuthRouter from "@/context/security/router/AuthRouter";
import {authModule} from "@/context/security/store";
import {facilityRoutes} from "@/context/facility/router/FacilityRoutes";
import {customerRoutesConfig} from "@/context/customer/router/CustomerRoutes";
import WorkPeriodTemplateRoutes from "@/context/work_period/router/WorkPeriodTemplateRoutes";
import CalculationRoutes from "@/context/calculation/router/CalculationRoutes";
import ModelRoutes from "@/context/model/router/ModelRoutes";
import {
  remoteConfigurationRouter
} from "@/context/remote_configuration/router/RemoteConfigurationRouter";
import {
  remoteConfigurationRoutesConfig
} from "@/context/remote_configuration/router/RemoteConfigurationRoutes";

Vue.use(VueRouter);
const lazyPage = () => import("@/context/dashboard/page/Dashboard.vue");

export const routes: Array<any> = [
  customerRoutesConfig,
  facilityRoutes.routeConfig,
  dataLoggerRoutes.routeConfig,
  new MeterRoutes().routeConfig,
  new SensorRoutes().routeConfig,
  WorkPeriodTemplateRoutes.instance().routeConfig,
  CalculationRoutes.instance().routeConfig,
  ModelRoutes.instance().routeConfig,
  remoteConfigurationRoutesConfig,
  {
    path: "/",
    url: "/",
    label: "Podsumowanie",
    name: "dashboard-show",
    component: lazyPage,
    icon: "mdi-view-dashboard",
    visible: true,
    meta: {
      secured: true
    }
  },
  ...AuthRoutes
];

const router = new VueRouter({
  routes
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.secured)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!authModule.isAuthenticated) {
      return next(AuthRouter.login());
    } else {
      return next(); // go to wherever I'm going
    }
  } else {
    return next(); // does not require auth, make sure to always call next()!
  }
});

export default router;
